
    <ng-container *ngIf="! standalone">
      <div class="form-group">
        <div class="d-flex d-flex-gap">
          <fieldmagic-text
            purpose="input"
            [content]="label"
            [withRequiredMarker]="withRequiredMarker"
          >
          </fieldmagic-text>

          <fieldmagic-icon
            *ngIf="tooltip | filled"
            icon="info-circle"
            [tooltip]="tooltip"
          >
          </fieldmagic-icon>
        </div>
        <ng-container *ngTemplateOutlet="input"></ng-container>
      </div>
    </ng-container>

    <ng-container
      *ngIf="standalone"
      [ngTemplateOutlet]="input"
    >
    </ng-container>

    <ng-template #input>
      <div class="d-flex d-flex-gap align-items-center">
        <fa-icon
          *ngIf="! displayOnly"
          class="fa-2x"
          [icon]="['fas', 'circle']"
          [style.color]="value"
          [(colorPicker)]="value"
          cpPosition="bottom"
          [cpCancelButton]="true"
          (colorPickerChange)="onChanged($event)"
        >
        </fa-icon>

        <fa-icon
          *ngIf="displayOnly"
          class="fa-2x"
          [icon]="['fas', 'circle']"
          [style.color]="value"
        >
        </fa-icon>

        <span *ngIf="displayValue">{{ value }}</span>
      </div>

      <div
        fieldmagicGridColumn="12"
      >
        <fieldmagic-input-errors
          *ngIf="errors | filled"
          [errors]="errors">
        </fieldmagic-input-errors>
      </div>
    </ng-template>
  